import React from 'react';
import { css } from '@emotion/react';
import { HeaderText, StickyCell } from './blocks';

export default function FooterCell({ cell, callbacks = {}, ...props }) {
    return (
        <StickyCell align="left" {...props}>
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                `}
            >
                <HeaderText>{cell.render('Footer', { callbacks })}</HeaderText>
            </div>
        </StickyCell>
    );
}
